import { GET_FACILITY_USERS_REQUESTED } from "./type";

export const getFacilityUsersRequested = (token: string) => {
  return {
    type: GET_FACILITY_USERS_REQUESTED,
    token
  };
};
